import { ConnectedSelectPage } from "fleet/controller/device/connected-select-page-v2";
import React from "react";
import { UPGRADE_DEVICES_FIRMWARE } from "redux-store/devices/actions";
import { needsFirmwareUpgrade } from "redux-store/devices/selectors";

function DeviceUpgradeFirmwarePage() {
  const successMessage =
    "Device firmware upgrade request processed " +
    "successfully. Your devices will be upgraded shortly.";

  return (
    <ConnectedSelectPage
      title="Upgrade Firmware"
      actionType={UPGRADE_DEVICES_FIRMWARE}
      upgradeDeviceFilter={needsFirmwareUpgrade}
      versionSelectorEnabled={false}
      successMessage={successMessage}
      startPage={0}
    />
  );
}

export { DeviceUpgradeFirmwarePage };
